import { ColumnDef } from "@tanstack/react-table"
import { format } from "date-fns"

import { MeterInfoType } from "@/types/meter"

import { DataTableColumnHeader } from "../../data-table"
import { Badge } from "../../ui/badge"
import { MeterInfoOperations } from "../operations/meter-info-operations"

export const meterInfoColumns: ColumnDef<MeterInfoType>[] = [
  {
    accessorKey: "serial_number",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Serial No." />
    ),
    cell: ({ row }) => {
      const value = row.original.serial_number
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "brand",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Brand" />
    ),
    cell: ({ row }) => {
      const value = row.original.brand
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "model",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Model" />
    ),
    cell: ({ row }) => {
      const value = row.original.model
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "size",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Size" />
    ),
    cell: ({ row }) => {
      const value = row.original.size
      return <div>{value}</div>
    },
  },
  
    {
      accessorKey: "status",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Status" />
      ),
      cell: ({ row }) => {
        const value = row.original.status
  
        const statusClasses: any = {
          Active: { 
            base: "bg-[#e6f7e6] text-[#00C853]", 
            hover: "hover:bg-[#c8e6c9]" 
          },
          Inactive: { 
            base: "bg-[#fffde0] text-[#d4af00]",
            hover: "hover:bg-[#fff8b0]"
          },
          Delinquent: { 
            base: "bg-[#fff0cc] text-[#F8961E]", 
            hover: "hover:bg-[#ffe0b2]" 
          },
          Disconnected: {
            base: "bg-[#ffebee] text-[#F44336]", 
            hover: "hover:bg-[#ffcdd2]" 
          },
          "Before Due": { 
            base: "bg-[#f3e5f5] text-[#9C27B0]", 
            hover: "hover:bg-[#e1bee7]" 
          },
          "Due Today": { 
            base: "bg-[#fce4ec] text-[#E91E63]", 
            hover: "hover:bg-[#f8bbd0]" 
          },
          "Over Due": { 
            base: "bg-[#f8e1ea] text-[#AD1457]", 
            hover: "hover:bg-[#f48fb1]" 
          },
          "Disconnection": { 
            base: "bg-[#ede7f6] text-[#673AB7]", 
            hover: "hover:bg-[#d1c4e9]" 
          },
          Pending: { 
            base: "bg-[#e3f2fd] text-[#2196F3]", 
            hover: "hover:bg-[#bbdefb]" 
          },
          Decommissioned: {
            base: "bg-[#fdf8e1] text-[#998100]",
            hover: "hover:bg-[#f1e6b3]"
          },

        };
    
        const currentStatus = statusClasses[value as keyof typeof statusClasses] || {
          base: "bg-gray-100 text-gray-600",
          hover: "hover:bg-gray-200"
        };
    
        return (
          <Badge
            className={`px-2 py-1 print:text-xl transition-colors duration-200 ${
              currentStatus.base
            } ${
              currentStatus.hover
            }`}
          >
            {value}
          </Badge>
        );
    },
  },

  {
    accessorKey: "purchase_date",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Purchase Date" />
    ),
    cell: ({ row }) => {
      const value = row.original.purchase_date
      return (
        <div>{value ? format(new Date(value), "MMM dd, yyyy") : "N/A"}</div>
      )
    },
  },
  {
    accessorKey: "decommission_date",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Decommission Date" />
    ),
    cell: ({ row }) => {
      const value = row.original.decommission_date
      return (
        <div>{value ? format(new Date(value), "MMM dd, yyyy") : "N/A"}</div>
      )
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <MeterInfoOperations data={row.original} />
        </div>
      )
    },
  },
]
